import { render } from "./ArticleImageRight.vue?vue&type=template&id=57d95ff8&scoped=true"
import script from "./ArticleImageRight.vue?vue&type=script&lang=js"
export * from "./ArticleImageRight.vue?vue&type=script&lang=js"

import "./ArticleImageRight.vue?vue&type=style&index=0&id=57d95ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d95ff8"]])

export default __exports__